import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { Settings } from '../../models/settings.model';
import * as SettingsActions from '../../store/actions/setting.action';
import { AppState } from '../../store/appstate.model';
import * as SettingsSelectors from '../../store/selectors/setting.selector';

@Injectable({
  providedIn: 'root',
})
export class SettingsFacadeService {
  public settingsState$ = this.store.select(SettingsSelectors.selectSettingFeature);
  public settings$ = this.store.select(SettingsSelectors.selectSettings);

  public constructor(private store: Store<AppState>) {}

  public loadSettings(): void {
    this.store.dispatch(SettingsActions.loadSettingState());
  }

  public saveSettings(settings: Settings): void {
    this.store.dispatch(SettingsActions.setSettings({ settings }));
  }
}
